<template>

  <t-dialog-form :generalErrors="generalErrors" :title="t('duplicate') + ' ' +  title" :ok-text="okText"
                 @hidden="onCloseDialog"
                 :id="id" :command="command"
                 :status="status"
                 ref="dialog_form" @onSubmit="onSubmit">

    <template>

      <b-card-title v-if="origin !== ''">Origem: {{ origin }}</b-card-title>

      <validation-observer ref="validation" v-slot="{invalid,errors}">

              <span class="display-none">
                {{ errorList = errors }}
                {{ isInvalid = invalid }}
              </span>

        <validation-observer ref="validation">

          <b-form @submit.prevent="onSubmit" ref="form">

            <t-form-wrapped :command="command" :status="onStatus">
              <slot :status="onStatus"></slot>
            </t-form-wrapped>

          </b-form>

        </validation-observer>

      </validation-observer>



    </template>

  </t-dialog-form>

</template>
<script>
import tDialogForm from "@/components/template/dialog/t-dialog-form";
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";

export default {
  name: "t-dialog-duplicate",
  components: {tDialogForm},
  mixins: [pageDialogFormMixin],
  data() {
    return {
      id: "modal-duplicate",
      okText: this.t('duplicate'),
    }
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    dialogId:{
      type:String,
      default:""
    },
    formError: {
      type: Object,
      default: null
    },
    origin: String,
    pathServer: {
      type: String,
      required: true,
    },
    command: {
      type: String,
      default: 'insert'
    },
    title: String,
  },
  mounted() {

    this.setValue()

    if(this.dialogId !== ''){
      this.id = this.dialogId
    }

  },
  computed: {
    onStatus() {
      return this.status
    },
    onSending() {
      return this.status === "sending"
    },
  },
  methods: {

    onCloseDialog() {

      this.$emit("onClose")

    }
    ,

    setValue() {
      this.form = this.value
    }
    ,

    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    async showModal() {

      //Limpa os campos
      this.resetModal()


    },

    async onSubmit() {

      //Validações específicas da tela

      this.form = this.value
      this.error = this.formError

      await this.setInsertDialog(this.pathServer + "/duplicate", (item) => {

        setTimeout(() => {

          //Fecha e devolve os valores desejado para continuidade
          this.$nextTick(() => {

            this.status = ""
            this.checkErrorsComponent = false

            this.$bvModal.hide(this.id)
            this.$emit('onSubmit', item)



          });

        }, 50)

      })

    }
  }
  ,
  watch: {

    value() {
      this.setValue()
    }

  }

}
</script>
